export enum UploadItemTypeEnum {
  FILE = 'file',
  URL = 'url',
}
